export enum TransactionField {
    NAME = 'name',
    AMOUNT = 'amount',
    DATE = 'date',
    TYPE = 'type',
    CATEGORY = 'category',
    OCCURRENCE = 'occurrence'
}
